import selectn          from 'selectn'
import { common }       from '../common'
import { XmlEntities }  from 'html-entities'
import moment           from 'moment'
import translate        from '../../../utils/translate'
import dateFormat       from '../../../utils/dateformat'
import ucFirst          from '../../../utils/ucFirst'
import eventSummary     from './eventSummary'
import parseUri         from '../../../utils/parseURI'
import { translateURI }     from '../../../utils/translateURI'

const entities = new XmlEntities()
const UNDEFINED = typeof void(0)
const TEAM_STATS_FILTER = {
  metres : 1,
  tackles : 1,
  missedtackles : 1,
  turnoverknockon : 1,
  territory : 1,
  possession : 1,
  runs : 1,
  passes : 1,
  kicksfromhand : 1,
  kickpercentsuccess : 1,
  penaltygoals : 1,
  tries : 1,
  conversiongoals : 1,
  pcpossessionfirst : 1,
  pcterritoryfirst : 1,
  pcpossessionsecond : 1,
  pcterritorysecond : 1,
  cleanbreaks : 1,
  defendersbeaten : 1,
  offload : 1,
  ruckswon : 1,
  ruckstotal : 1,
  turnoversconceded : 1,
  maulswon : 1,
  maulstotal : 1,
  totalfreekicksconceded : 1,
  totallineouts : 1,
  lineoutswon : 1,
  scrumstotal : 1,
  scrumswon : 1,
  penaltiesconceded : 1,
  yellowcards : 1,
  redcards : 1
}
const PLAYER_STATS_FILTER = {
  tries : 1,
  tryassists : 1,
  points : 1,
  kicks : 1,
  passes : 1,
  runs : 1,
  metres : 1,
  cleanbreaks : 1,
  defendersbeaten : 1,
  offload : 1,
  lineoutwonsteal : 1,
  turnoversconceded : 1,
  tackles : 1,
  missedtackles : 1,
  lineoutswon : 1,
  penaltiesconceded : 1,
  yellowcards : 1,
  redcards : 1,
  penalties : 1,
  penaltygoals : 1,
  conversiongoals : 1,
  dropgoalsconverted : 1
}
const DETAIL_TO_STATISTIC = {
  1 : 'tries',
  2 : 'conversiongoals',
  3 : 'penalties',
  5 : 'yellowcards',
  6 : 'redcards'
}
const SUPRESS_EVENT_DUPLICATES = {
  9:1,
  10:1,
  11:1,
  12:1
}

const helpers = {

  formatNubmer : function ( x ) {
    let parts = x.toString().split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return parts.join('.')
  },

  roundValue : function (x) {
    return parseInt(x)
    //Math.round
    //parseInt
  },

  sumArray : function ( arrayVal ) {
    if (arrayVal && arrayVal.constructor === Array) {
      return arrayVal.reduce(function (total, num) {
        return total + (num * 1)
        //Number()
      }, 0)
    }
    return (arrayVal * 1)
  },

  percentValue : function ( total, quantity ) {
    /* default */
    total = total || 0
    quantity = quantity || 0

    /* format */
    total = this.sumArray(total)
    quantity = this.sumArray(quantity)

    if (!total) {
      return 0
    }
    return this.roundValue((quantity / total) * 100)
  },

  /**
   * Get standings link details
   * @param  {Object} edition   Edition details
   * @param  {Object} params    Router params
   * @return {Object}           Link title and href
   */
  getStandingsLink : function ( edition = {}, params = {} ) {

    const league = params.league || 0
    const link = {
      title : translate(edition, 'Full Table')
    }

    if (league) {
      link.href = common.createHref({
        ...params,
        pageType : (edition.language === 'es' || edition.language === 'pt') ? 'standings' : 'table'
      })
    }

    //Translate the url
    let localizedHref = translateURI(edition, { url: link.href }, false)
    link.href = localizedHref.url

    return link
  },

  /**
   * Logic to determine if polling should be enabled
   * for the game
   * @param  {String} date      competition.date
   * @param  {String} gameState game state
   * @return {Object}           Polling details
   */
  shouldPoll : function (date = '', gameState = '') {
    const duration = 45000
    let enabled = false

    if (gameState === 'live') {
      enabled = true
    }
    const startTime = moment.utc(new Date())
    const endTime = moment(date)
    const diff = endTime.diff(startTime, 'hours')
    // console.log(startTime.format(), endTime.format(), diff)
    // TODO: update logic
    // polling 12 hours, before and after the game
    if (Math.abs(diff) <= 1) {
      enabled = true
    }
    return {
      enabled,
      duration
    }
  },

  getAnalytics( params = {}, teams = {}, meta = {}, gameState ) {
    const { home = {}, away = {} } = teams
    const isSummary = params.pageType === 'game'
    const isLive = gameState === 'live'
    let type = isSummary ? ( isLive ? 'live' : 'summary' ) : params.pageType
    type = (type === 'video') ? 'videos' : type
    const contentType = `game${type ? ':' + type : ''}`
    let gameStateProp = 'pre'

    switch(gameState) {
      case 'live':
        gameStateProp = 'Live'
        break
      case 'final':
        gameStateProp = 'post'
        break
    }

    const data = {
      omniture: {
        gameState : gameStateProp,
        pageName  : `${params.sport}:${contentType}`,
        gameInfo  : `${params.gameId}+${home.name} vs ${away.name}`,
        eVar44    : 'gamepackage',
        league    : params.league,
        contentType
      },
      chartbeat: {
        title     : meta.title
      }
    }
    return data
  },

  getMetaData : function ( edition = {}, params, competition = {}, gameStrip = {} , matchDetails = {}, leagueName = '', gameState, league = {}, matchCoverage, matchDescription = '', hrefConfig = {} ) {
    const meta = {}

    const date          = dateFormat.dateFormat( competition.date, 'D MMM, YYYY', edition.timeZoneBucket )
    const teams         = gameStrip.teams || {}
    const homeTeam      = teams.home || {}
    const homeTeamName  = homeTeam.name || ''
    const awayTeam      = teams.away || {}
    const awayTeamName  = awayTeam.name || ''

    let { sport = '', pageType = '' } = params
    let titleInsert = ''
    let metaDescSuffix = ''
    let regex = /\/(ios|android)\/webview/g
    let gameTitle = ''
    let gameKeywords = ''
    let gameDescription = ''

    // team abbreviations
    let homeTeamAbbr = selectn('home.abbrev', teams) || ''
    let awayTeamAbbr = selectn('away.abbrev', teams) || ''

    // If abbreviation is not found, set abbreviation to team name
    if (homeTeamAbbr === '') {
      homeTeamAbbr = homeTeamName
    }
    if (awayTeamAbbr === '') {
      awayTeamAbbr = awayTeamName
    }

    switch (pageType.toLowerCase()) {
      case 'game':
      case 'match':
        titleInsert = 'Summary'
        metaDescSuffix = 'Get a summary of'
        break
      case 'report':
        titleInsert = 'Report'
        metaDescSuffix = 'Get a report of'
        break
      case 'preview':
        titleInsert = 'Preview'
        metaDescSuffix = 'Get a preview of'
        break
      case 'matchstats':
        titleInsert = 'Match Statistics'
        metaDescSuffix = 'Get match statistics of'
        break
      case 'playerstats':
        titleInsert = 'Player Statistics'
        metaDescSuffix = 'Get the player statistics of'
        break
      case 'commentary':
        titleInsert = 'Commentary'
        metaDescSuffix = 'Follow commentary on'
        break
      case 'lineups':
        titleInsert = 'Line-up'
        metaDescSuffix = 'Get the match line-ups of'
        break
      case 'conversation':
        titleInsert = 'Conversation'
        metaDescSuffix = 'Follow live conversation of'
        break
    }

    // Additional info required by Native APP
    let canonical = common.createHref({ ...params, ...hrefConfig }) || ''
    let shareurl = canonical.replace(regex, '')
    const vs = translate(edition, 'schedule.vs')
    meta.gameId       = competition.id || ''
    meta.gameState    = selectn('status.type.state', competition) || ''
    meta.leagueId     = league.id || ''
    meta.leagueUID    = league.uid || ''
    meta.leagueName   = league.name || ''
    meta.matchDescription = matchDescription
    meta.sport        = sport
    meta.title        = `${homeTeamName} vs ${awayTeamName} - ${titleInsert} - ${leagueName} - ${date} - ESPN`
    meta.keywords     = `${homeTeamName} vs ${awayTeamName}, ${titleInsert.toLowerCase()}, ${leagueName}, rugby`
    meta.description  = `${metaDescSuffix} the ${homeTeamName} vs ${awayTeamName} ${leagueName} rugby match.`
    meta.canonical    = canonical
    meta.shareurl     = shareurl
    meta.website      = 'article'
    meta.shortTitle   =  meta.shortTitle = `${homeTeamAbbr} vs ${awayTeamAbbr}`
    meta.competitionUID = competition.uid || ''
    meta.image        = 'https://a.espncdn.com/combiner/i?img=%2Fi%2Fespn%2Fespn_logos%2Fespn_red.png'
    gameTitle = `${homeTeamName} ${vs} ${awayTeamName} - ${titleInsert} - ${leagueName} - ${date}`
    gameKeywords = `${homeTeamName} ${vs} ${awayTeamName}, ${titleInsert}, ${leagueName} ${date}`
    gameDescription = `${homeTeamName} ${vs} ${awayTeamName}, ${leagueName} ${date}`
    if ( params.sport === 'rugby' && params.gameId != '' && params.league != '' ) {
      let titleTransObj = {
        key : 'meta.title.rugby.gamepackage',
        game : gameTitle
      }
      let descriptionTransObj = {
        key : 'meta.description.rugby.gamepackage',
        game : gameDescription
      }
      let keywordsTransObj = {
        key : 'meta.keywords.rugby.gamepackage',
        game : gameKeywords
      }
      meta.title = translate(edition, titleTransObj) || ''
      meta.description = translate(edition, descriptionTransObj) || ''
      meta.keywords = translate(edition, keywordsTransObj) || ''
    } else {
      meta.title        = `${homeTeamName} ${vs} ${awayTeamName} - ${titleInsert} - ${leagueName} - ${date} - ESPN`
      meta.keywords     = `${homeTeamName} ${vs} ${awayTeamName}, ${titleInsert.toLowerCase()}, ${leagueName}, rugby`
      meta.description  = `${metaDescSuffix} the ${homeTeamName} ${vs} ${awayTeamName} ${leagueName} rugby match.`
    }
    return meta
  }
}

const modules = {

  setMatchDetails : function ( params = {}, rosters, competition, boxScore ) {

    const sport = params.sport || 'rugby'
    let rPlayers = {}
    let rPlayerOrder = {
      home : {
        playerList : [],
        playerMap : {}
      },
      away : {
        playerList : [],
        playerMap : {}
      }
    }
    let rTeam = {}
    let aEventData = []
    let penalties = {
      home : [],
      away : []
    }
    let rGlossary = {
      teamStats : {},
      playerStats : {},
      playerPositons : {}
    }
    let teamSize = 15
    let subOnId = 8
    let subOffId = 7

    if( sport == 'rugby-league' ) {
      subOffId = 17
    }

    /* Get Team details from competition node */
    const aCompetitors = selectn('competitors', competition) || []
    const iCompetitorLen = aCompetitors !== null ? aCompetitors.length : 0
    for (let i = 0; i < iCompetitorLen; i++) {
      let oTeam = this.setTeamDetails(aCompetitors[i], boxScore, rGlossary)
      rTeam[oTeam.homeAway] = oTeam
    }

    /* Get initial player data from roster node */
    for (let i in rosters) {

      /* don't rely on API order for rugby league - NEEDS API amended in future */
      const currentRoster = rosters[i].roster || []
      if( sport === 'rugby-league' ) {
        currentRoster.sort( function ( a, b ) {
          if( isNaN(a.jersey) || isNaN(b.jersey) ) {
            return -1
          }
          return ( parseInt(a.jersey) - parseInt(b.jersey) )
        })
      }

      for (let x in currentRoster) {
        let oPlayer = this.setPlayerDetails( sport, currentRoster[x], rGlossary)
        oPlayer.homeAway = selectn('homeAway', rosters[i]) || ''
        if ( x < teamSize ) {
          oPlayer.onPitch = true
          oPlayer.wasActive = true
        }

        if (!oPlayer.homeAway) {
          continue
        }

        /* store player in map and in team */
        rPlayers[oPlayer.id] = oPlayer
        rPlayerOrder[oPlayer.homeAway].playerList.push(oPlayer.id)
        rPlayerOrder[oPlayer.homeAway].playerMap[oPlayer.id] = (rPlayerOrder[oPlayer.homeAway].playerList.length - 1)
      }
    }

    /* loop every event and build up player activities and times */
    const aEvents = selectn('details', competition) || []
    const iEventLen = aEvents !== null ? aEvents.length : 0
    let oSub = {}
    let showOnce = {}
    for (let i = 0; i < iEventLen; i++) {
      const oEvent = aEvents[i]
      const sType = parseInt(selectn('type.id', oEvent)) || 0

      if ( SUPRESS_EVENT_DUPLICATES[sType] ) {
        if ( !showOnce[sType] ) {
          showOnce[sType] = 1
        } else {
          continue
        }
      }

      const iAthleteId = selectn('participants[0].athlete.id', oEvent) || 0
      const sEventTime = selectn('clock.displayValue', oEvent) || selectn('time.displayValue', oEvent) || ''
      let sEventText = selectn('text', oEvent) || selectn('type.text', oEvent) || ''

      if ( sType <= 8 && sport != 'rugby-league' ) {
        sEventText += ' - ' + selectn('participants[0].athlete.displayName', oEvent) + ' , ' + selectn('team.displayName', oEvent)
      }

      if ( sType != 9999 ) {
        sEventText = ucFirst(sEventText)
      }

      /* Store the event data */
      const oEventData = {
        type : sType,
        text : entities.encode(sEventText),
        /* for performance check to see if has html */
        time : sEventTime,
        homeScore : selectn('homeScore', oEvent) || 0,
        awayScore : selectn('awayScore', oEvent) || 0
      }
      aEventData.push(oEventData)

      if (!iAthleteId || typeof rPlayers[iAthleteId] === 'undefined') {
        if ( sType === 14 ) {
          /* Penalty Try */
          const penTeamId = selectn('team.id', oEvent) || 0
          if ( selectn('home.id', rTeam) == penTeamId ) {
            penalties.home.push( sEventTime )
          } else {
            penalties.away.push( sEventTime )
          }
        }
        continue
      }

      if (sType === subOnId || sType === subOffId ) {

        // assume if this tryp then they got some pitch time
        rPlayers[iAthleteId].wasActive = true
        const sTeam = rPlayers[iAthleteId]['homeAway'] || ''
        const sTime = selectn('clock.value', oEvent) || ''

        if (typeof oSub[sTeam] === 'undefined') {
          oSub[sTeam] = {}
        }

        if (typeof oSub[sTeam][sTime] === 'undefined') {
          oSub[sTeam][sTime] = {
            in : null,
            out : null
          }
        }

        if (sType === subOffId ) {
          oSub[sTeam][sTime].displayTime = sEventTime
          oSub[sTeam][sTime].out = iAthleteId
          rPlayers[iAthleteId].onPitch = false
        } else {
          oSub[sTeam][sTime].displayTime = sEventTime
          oSub[sTeam][sTime].in = iAthleteId
          rPlayers[iAthleteId].onPitch = true
        }

      } else {
        // build an array of every type and time.
        if (typeof rPlayers[iAthleteId].eventTimes[sType] === 'undefined') {
          rPlayers[iAthleteId].eventTimes[sType] = []
        }
        rPlayers[iAthleteId].eventTimes[sType].push(selectn('clock.displayValue', oEvent) || 0)
      }
    }

    /* for some reason details can have more data than stats so we now overide player stats data with accumulated detail data */
    for (let key in rPlayers) {
      if (!rPlayers.hasOwnProperty(key)) {
        continue
      }
      for (let eventKey in rPlayers[key].eventTimes) {
        if (!rPlayers[key].eventTimes.hasOwnProperty(eventKey)) {
          continue
        }
        if (typeof DETAIL_TO_STATISTIC[eventKey] !== 'undefined') {
          let iEventLen = (typeof rPlayers[key].eventTimes[eventKey] !== 'undefined') ? rPlayers[key].eventTimes[eventKey].length : 0
          rPlayers[key][DETAIL_TO_STATISTIC[eventKey]].value = iEventLen
        }
      }
    }

    /* now we know who subbed who we need to map these changes into positions. */

    for (const sTeam in oSub) {
      if (oSub.hasOwnProperty(sTeam)) {

        // sort by time
        const aTime = Object.keys(oSub[sTeam]).sort()
        const iLen = aTime.length

        for (let i = 0; i < iLen; i++) {
          const oSubstitute = oSub[sTeam][aTime[i]]

          if (oSubstitute.in !== null && oSubstitute.out !== null) {
            /*
            const iCurrPosIn = rPlayerOrder[sTeam].playerMap[oSubstitute.in]
            const iCurrPosOut = rPlayerOrder[sTeam].playerMap[oSubstitute.out]

            // move the player
            rPlayerOrder[sTeam].playerList[iCurrPosIn] = oSubstitute.out
            rPlayerOrder[sTeam].playerList[iCurrPosOut] = oSubstitute.in
            rPlayerOrder[sTeam].playerMap[oSubstitute.out] = iCurrPosIn
            rPlayerOrder[sTeam].playerMap[oSubstitute.in] = iCurrPosOut


            // set tooltip text
            rPlayers[oSubstitute.in].subToolTip = '(' + oSubstitute.displayTime + ') ' + rPlayers[oSubstitute.out].name
            rPlayers[oSubstitute.in].subbed = true
            */
          }
        }
      }
    }


    /* put players into team in order */
    for (const sTeam in rTeam) {
      if (rTeam.hasOwnProperty(sTeam)) {
        for (let iPlayerId of rPlayerOrder[sTeam].playerList) {
          rTeam[sTeam].squad.push(rPlayers[iPlayerId])
        }
      }
    }

    rTeam.events = aEventData.reverse() || []
    rTeam.glossary   = rGlossary
    rTeam.gameState  = common.getGameState(selectn('status.type.state', competition))
    rTeam.penalties  = penalties
    return rTeam
  },

  setPlayerDetails : function ( sport = 'rugby', rosterData = {}, glossary = {} ) {

    let playerUrl = ''
    if ( sport == 'rugby' ) {
      playerUrl = selectn('athlete.links[0].href', rosterData) || ''
    }
    /* Set initial player values and defaults based on roster */
    let oPlayer = {
      id : selectn('athlete.id', rosterData) || 0,
      uid : selectn('athlete.uid', rosterData) || '',
      guid : selectn('athlete.guid', rosterData) || '',
      url : playerUrl,
      name : selectn('athlete.displayName', rosterData) || '',
      number : selectn('jersey', rosterData) || 0,
      position : selectn('position.abbreviation', rosterData) || '',
      captain : selectn('capatin', rosterData) || false,
      subbed : false,
      homeAway : '',
      subToolTip : '',
      eventTimes : {},
      onPitch : false,
      wasActive : false
    }

    /* loop filter to build defaults */
    for (let key in PLAYER_STATS_FILTER) {
      if (PLAYER_STATS_FILTER.hasOwnProperty(key)) {
        oPlayer[key] = {}
        oPlayer[key].value = '0'
        oPlayer[key].name = key
      }
    }

    /* loop stats and pull out the filtered stats */
    const aStats = selectn('stats', rosterData) || []
    const iStatsLen = aStats !== null ? aStats.length : 0
    for (let i = 0; i < iStatsLen; i++) {
      const oStat = aStats[i]
      const sStatName = oStat.type
      if (PLAYER_STATS_FILTER[sStatName]) {
        oPlayer[sStatName].value = oStat.displayValue
        oPlayer[sStatName].name = oStat.displayName
        if (typeof glossary.playerStats[sStatName] === 'undefined') {
          glossary.playerStats[sStatName] = {}
          glossary.playerStats[sStatName].abbr = oStat.abbreviation
          glossary.playerStats[sStatName].desc = oStat.description || oStat.displayName
        }
      }
    }

    return oPlayer
  },

  setTeamDetails : function (competitorData, boxScoreData, glossary) {

    let oTeam = {
      id : selectn('id', competitorData) || 0,
      url : selectn('team.links[0].href', competitorData) || '',
      name : selectn('team.displayName', competitorData) || '',
      abbreviation : selectn('team.abbreviation', competitorData) || '',
      color : selectn('team.color', competitorData) ? '#' + selectn('team.color', competitorData) : ( selectn('homeAway', competitorData) == 'home' ? '#999' : '#d7d7d7' ),
      homeAway : selectn('homeAway', competitorData) || '',
      form : selectn('form', competitorData) || '',
      winner : selectn('winner', competitorData) || false,
      squad : [],
      logo : common.getTeamLogo(selectn('team', competitorData) || {})
    }

    /* loop filter to build defaults */
    for (let key in TEAM_STATS_FILTER) {
      if (TEAM_STATS_FILTER.hasOwnProperty(key)) {
        oTeam[key] = {}
        oTeam[key].value = '0'
        oTeam[key].name = ''
      }
    }

    /* find the team stats in the boxscore and pull out the filtered values */
    const iTeamAId = selectn('teams[0].team.id', boxScoreData) || 0
    let aStats = iTeamAId === oTeam.id ? selectn('teams[0].statistics[0].stats', boxScoreData) || [] : selectn('teams[1].statistics[0].stats', boxScoreData) || []
    const iStatsLen = aStats !== null ? aStats.length : 0
    for (let i = 0; i < iStatsLen; i++) {
      const oStat = aStats[i]
      const sStatName = oStat.type
      if (TEAM_STATS_FILTER[sStatName]) {
        oTeam[sStatName].name = oStat.displayName
        if (sStatName === 'possession' || sStatName === 'territory' || sStatName === 'kickpercentsuccess' || sStatName === 'pcpossessionfirst' || sStatName === 'pcterritoryfirst' || sStatName === 'pcpossessionsecond' || sStatName === 'pcterritorysecond') {
          oTeam[sStatName].value = helpers.roundValue(Math.round(oStat.displayValue * 100))
        } else {
          oTeam[sStatName].value = oStat.displayValue
        }
        if (typeof glossary.teamStats[sStatName] === 'undefined') {
          glossary.teamStats[sStatName] = {}
          glossary.teamStats[sStatName].abbr = oStat.abbreviation
          glossary.teamStats[sStatName].desc = oStat.description || oStat.displayName
        }
      }
    }

    return oTeam
  },

  getMatchDetails : function (edition, gameInfo, competition) {

    let attendance = selectn('attendance', gameInfo) || 0
    let capacity = selectn('venue.capacity', gameInfo) || 0
    let date = competition.date || ''
    let percent = 0

    if (attendance && capacity) {
      percent = helpers.percentValue(capacity, attendance)
      if (percent > 100) {
        percent = 100
      }
    }

    attendance = helpers.formatNubmer(attendance)
    capacity = helpers.formatNubmer(capacity)

    if (date !== '') {
      date = dateFormat.dateFormat( date, 'dateTime1', edition.timeZoneBucket )
    }

    return {
      coverage : '',
      venue : selectn('venue.fullName', gameInfo) || selectn('venue.shortName', gameInfo) || '',
      address : selectn('venue.address.summry', gameInfo) || '',
      attendance : attendance,
      percent : percent,
      capacity : capacity,
      date : date,
      text : {
        attendance : translate(edition, 'Attendance'),
        heading : translate(edition, 'Game Info'),
        capacity : translate(edition, 'Capacity'),
        venue : translate(edition, 'Venue'),
        coverage : translate(edition, 'Coverage')
      }
    }
  },

  getArticle : function ( articleData = {}, params = {} ) {

    const sport = params.sport || 'rugby'
    let articleLink = selectn('links.web.href', articleData) || ''
    const isWebView = params.platform ? true : false
    let oArticle = {
      id          : selectn('id', articleData) || 0,
      type        : selectn('type', articleData) || 0,
      headline    : selectn('headline', articleData) || '',
      description : selectn('description', articleData) || '',
      source      : selectn('byline', articleData) || '',
      date        : selectn('originallyPosted', articleData) || selectn('lastModified', articleData) || '',
      href        : articleLink,
      video       : selectn('video', articleData) || {},
      images      : selectn('images', articleData) || []
    }

    //let editionsHost = this.window ? this.window.location.host : 'www.espn.co.uk'
    //this.data.Article.link = espnURL(this.data.Article.link,editionsHost);

    // Due to the migration of the links the url is wrong this will correct it
    if ( articleLink.indexOf('recap') > -1 || articleLink.indexOf('report') > -1 ) {
      articleLink = common.createHref({
        pageType : 'report',
        sport : sport,
        league : params.league,
        gameId : params.gameId,
        platform: params.platform,
        webview: params.webview
      })
    } else if ( articleLink.indexOf('preview') > -1 ) {
      articleLink = common.createHref({
        pageType : 'preview',
        sport : sport,
        league : params.league,
        gameId : params.gameId,
        platform: params.platform,
        webview: params.webview
      })
    }

    oArticle.href = !isWebView ? common.buildURL( articleLink ) : articleLink

    return oArticle
  },

  getMatchStats : function (edition, params, query, data, boxScoreNode) {

    const sport = params.sport || 'rugby'
    const lang = edition && edition.language
    const isTeamLinkActive = common.getIsTeamLinkActive(params.sport, lang)
    const possessionText = selectn('away.possession.name', data) || ''
    const territoryText = selectn('away.territory.name', data) || ''
    const statsNode = selectn('teams[0].statistics', boxScoreNode) || []
    const isStatsAvailable = !!statsNode.length
    return {
      sport : sport,
      isStatsAvailable : isStatsAvailable,
      title : translate(edition, 'Match Stats'),
      link : common.buildLinkObject({
        text : translate(edition, 'Full Match Stats'),
        tracking : [ sport, 'game', 'subnav', 'matchstats' ],
        params : {
          pageType : 'matchstats',
          sport : sport,
          league : params.league,
          gameId : params.gameId,
          platform: params.platform,
          webview: params.webview
        },
        query : query,
        edition : edition
      }),
      home : {
        name : selectn('home.abbreviation', data),
        logo : selectn('home.logo', data),
        color : selectn('home.color', data)
      },
      away : {
        name : selectn('away.abbreviation', data),
        logo : selectn('away.logo', data),
        color : selectn('away.color', data)
      },
      table : [
        {
          homeValue : selectn('home.runs.value', data),
          awayValue : selectn('away.runs.value', data),
          text : selectn('away.runs.name', data)
        }, {
          homeValue : selectn('home.metres.value', data),
          awayValue : selectn('away.metres.value', data),
          text : selectn('away.metres.name', data)
        }, {
          homeValue : selectn('home.cleanbreaks.value', data),
          awayValue : selectn('away.cleanbreaks.value', data),
          text : selectn('away.cleanbreaks.name', data)
        }, {
          homeValue : selectn('home.tackles.value', data),
          awayValue : selectn('away.tackles.value', data),
          text : selectn('away.tackles.name', data)
        }, {
          homeValue : selectn('home.missedtackles.value', data),
          awayValue : selectn('away.missedtackles.value', data),
          text : selectn('away.missedtackles.name', data)
        }, {
          homeValue : selectn('home.turnoverknockon.value', data),
          awayValue : selectn('away.turnoverknockon.value', data),
          text : selectn('away.turnoverknockon.name', data)
        }
      ],
      dataVis : [
        {
          homeValue : selectn('home.possession.value', data),
          awayValue : selectn('away.possession.value', data),
          homeText : selectn('home.possession.value', data) ? selectn('home.possession.value', data) + '%' : '0%',
          awayText : selectn('away.possession.value', data) ? selectn('away.possession.value', data) + '%' : '0%',
          text : translate(edition, possessionText)
        }, {
          homeValue : selectn('home.territory.value', data),
          awayValue : selectn('away.territory.value', data),
          homeText : selectn('home.territory.value', data) ? selectn('home.territory.value', data) + '%' : '0%',
          awayText : selectn('away.territory.value', data) ? selectn('away.territory.value', data) + '%' : '0%',
          text : translate(edition, territoryText)
        }
      ],
      isTeamLinkActive : isTeamLinkActive // Added to check active/inactive team links
    }

  },

  getMatchEvents : function (edition, data) {

    const percVal = helpers.percentValue( [ selectn('home.metres.value', data), selectn('away.metres.value', data) ], selectn('home.metres.value', data) )

    return {
      title : [
        translate(edition, 'Match Events'),
        translate(edition, 'Kick/Pass/Run')
      ],
      split : true,
      home : {
        name : selectn('home.abbreviation', data),
        logo : selectn('home.logo', data),
        color : selectn('home.color', data)
      },
      away : {
        name : selectn('away.abbreviation', data),
        logo : selectn('away.logo', data),
        color : selectn('away.color', data)
      },
      col : [
        [
          {
            type : 'table',
            data : [
              {
                homeValue : selectn('home.tries.value', data),
                awayValue : selectn('away.tries.value', data),
                text : selectn('away.tries.name', data)
              }, {
                homeValue : selectn('home.conversiongoals.value', data),
                awayValue : selectn('away.conversiongoals.value', data),
                text : selectn('away.conversiongoals.name', data)
              }, {
                homeValue : selectn('home.penaltygoals.value', data),
                awayValue : selectn('away.penaltygoals.value', data),
                text : selectn('away.penaltygoals.name', data)
              }, {
                homeValue : selectn('home.kickpercentsuccess.value', data) ? selectn('home.kickpercentsuccess.value', data) + '%' : '0%',
                awayValue : selectn('away.kickpercentsuccess.value', data) ? selectn('away.kickpercentsuccess.value', data) + '%' : '0%',
                text : selectn('away.kickpercentsuccess.name', data) || 'Kick at Goal Success'
              }
            ]
          }
        ],
        [
          {
            type : 'dataVis',
            data : {
              homeValue : percVal,
              homeText : selectn('home.metres.value', data),
              awayText : selectn('away.metres.value', data),
              text : selectn('away.metres.name', data)
            }
          }, {
            type : 'table',
            data : [
              {
                homeValue : selectn('home.kicksfromhand.value', data),
                awayValue : selectn('away.kicksfromhand.value', data),
                text : selectn('away.kicksfromhand.name', data)
              }, {
                homeValue : selectn('home.passes.value', data),
                awayValue : selectn('away.passes.value', data),
                text : selectn('away.passes.name', data)
              }, {
                homeValue : selectn('home.runs.value', data),
                awayValue : selectn('away.runs.value', data),
                text : selectn('away.runs.name', data)
              }
            ]
          }
        ]
      ]
    }
  },

  getMatchAttacking : function (edition, data) {

    const homePos = selectn('home.pcpossessionfirst.value', data) + '% / ' + selectn('home.pcpossessionsecond.value', data) + '%'
    const awayPos = selectn('away.pcpossessionfirst.value', data) + '% / ' + selectn('away.pcpossessionsecond.value', data) + '%'
    const homeTer = selectn('home.pcterritoryfirst.value', data) + '% / ' + selectn('home.pcterritorysecond.value', data) + '%'
    const awayTer = selectn('away.pcterritoryfirst.value', data) + '% / ' + selectn('away.pcterritorysecond.value', data) + '%'
    const homeRuck = selectn('home.ruckswon.value', data) + ' / ' + selectn('home.ruckstotal.value', data) + ' (' + helpers.percentValue(selectn('home.ruckstotal.value', data), selectn('home.ruckswon.value', data)) + '%)'
    const awayRuck = selectn('away.ruckswon.value', data) + ' / ' + selectn('away.ruckstotal.value', data) + ' (' + helpers.percentValue(selectn('away.ruckstotal.value', data), selectn('away.ruckswon.value', data)) + '%)'
    const homeMaul = selectn('home.maulswon.value', data) + ' / ' + selectn('home.maulstotal.value', data) + ' (' + helpers.percentValue(selectn('home.maulstotal.value', data), selectn('home.maulswon.value', data)) + '%)'
    const awayMaul = selectn('away.maulswon.value', data) + ' / ' + selectn('away.maulstotal.value', data) + ' (' + helpers.percentValue(selectn('away.maulstotal.value', data), selectn('away.maulswon.value', data)) + '%)'

    return {
      title : translate(edition, 'Attacking'),
      split : false,
      home : {
        name : selectn('home.abbreviation', data),
        logo : selectn('home.logo', data),
        color : selectn('home.color', data)
      },
      away : {
        name : selectn('away.abbreviation', data),
        logo : selectn('away.logo', data),
        color : selectn('away.color', data)
      },
      col : [
        [
          {
            type : 'dataVis',
            data : {
              homeValue : selectn('home.possession.value', data),
              awayValue : selectn('away.possession.value', data),
              homeText : selectn('home.possession.value', data) ? selectn('home.possession.value', data) + '%' : '0%',
              awayText : selectn('away.possession.value', data) ? selectn('away.possession.value', data) + '%' : '0%',
              text : selectn('away.possession.name', data)
            }
          }, {
            type : 'dataVis',
            size : 'large',
            data : {
              homeValue : selectn('home.territory.value', data),
              awayValue : selectn('away.territory.value', data),
              homeText : selectn('home.territory.value', data) ? selectn('home.territory.value', data) + '%' : '0%',
              awayText : selectn('away.territory.value', data) ? selectn('away.territory.value', data) + '%' : '0%',
              text : selectn('away.territory.name', data)
            }
          }
        ],
        [
          {
            type : 'table',
            data : [
              {
                homeValue : homePos,
                awayValue : awayPos,
                text : translate(edition, 'Possession 1H/2H')
              }, {
                homeValue : homeTer,
                awayValue : awayTer,
                text : translate(edition, 'Territory 1H/2H')
              }, {
                homeValue : selectn('home.cleanbreaks.value', data),
                awayValue : selectn('away.cleanbreaks.value', data),
                text : selectn('away.cleanbreaks.name', data)
              }, {
                homeValue : selectn('home.defendersbeaten.value', data),
                awayValue : selectn('away.defendersbeaten.value', data),
                text : selectn('away.defendersbeaten.name', data)
              }, {
                homeValue : selectn('home.offload.value', data),
                awayValue : selectn('away.offload.value', data),
                text : selectn('away.offload.name', data)
              }, {
                homeValue : homeRuck,
                awayValue : awayRuck,
                text : selectn('away.ruckswon.name', data)
              }, {
                homeValue : homeMaul,
                awayValue : awayMaul,
                text : selectn('away.maulswon.name', data)
              }, {
                homeValue : selectn('home.turnoversconceded.value', data),
                awayValue : selectn('away.turnoversconceded.value', data),
                text : selectn('away.turnoversconceded.name', data)
              }
            ]
          }
        ]
      ]
    }
  },

  getMatchAttackingRL : function (edition, data) {

    const homePos = selectn('home.pcpossessionfirst.value', data) + '% / ' + selectn('home.pcpossessionsecond.value', data) + '%'
    const awayPos = selectn('away.pcpossessionfirst.value', data) + '% / ' + selectn('away.pcpossessionsecond.value', data) + '%'
    const homeTer = selectn('home.pcterritoryfirst.value', data) + '% / ' + selectn('home.pcterritorysecond.value', data) + '%'
    const awayTer = selectn('away.pcterritoryfirst.value', data) + '% / ' + selectn('away.pcterritorysecond.value', data) + '%'

    return {
      title : [
        translate(edition, 'Attacking'),
        translate(edition, 'Defending')
      ],
      split : true,
      home : {
        name : selectn('home.abbreviation', data),
        logo : selectn('home.logo', data),
        color : selectn('home.color', data)
      },
      away : {
        name : selectn('away.abbreviation', data),
        logo : selectn('away.logo', data),
        color : selectn('away.color', data)
      },
      col : [
        [
          {
            type : 'table',
            data : [
              {
                homeValue : homePos,
                awayValue : awayPos,
                text : translate(edition, 'Possession 1H/2H')
              }, {
                homeValue : homeTer,
                awayValue : awayTer,
                text : translate(edition, 'Territory 1H/2H')
              }, {
                homeValue : selectn('home.cleanbreaks.value', data),
                awayValue : selectn('away.cleanbreaks.value', data),
                text : selectn('away.cleanbreaks.name', data)
              }, {
                homeValue : selectn('home.defendersbeaten.value', data),
                awayValue : selectn('away.defendersbeaten.value', data),
                text : selectn('away.defendersbeaten.name', data)
              }, {
                homeValue : selectn('home.offload.value', data),
                awayValue : selectn('away.offload.value', data),
                text : selectn('away.offload.name', data)
              }, {
                homeValue : selectn('home.turnoversconceded.value', data),
                awayValue : selectn('away.turnoversconceded.value', data),
                text : selectn('away.turnoversconceded.name', data)
              }
            ]
          }
        ],
        [
          {
            type : 'dataVisPie',
            data : {
              homeTotal : (selectn('home.tackles.value', data) * 1) + (selectn('home.missedtackles.value', data) * 1),
              homeWon : selectn('home.tackles.value', data),
              awayTotal : (selectn('away.tackles.value', data) * 1) + (selectn('away.missedtackles.value', data) * 1),
              awayWon : selectn('away.tackles.value', data),
              text : selectn('away.tackles.name', data)
            }
          }
        ]
      ]
    }
  },

  getMatchDefending : function (edition, data) {

    return {
      title : [
        translate(edition, 'Set Pieces'),
        translate(edition, 'Defending')
      ],
      split : true,
      home : {
        name : selectn('home.abbreviation', data) || 'TBC',
        logo : selectn('home.logo', data) || '',
        color : selectn('home.color', data) || ''
      },
      away : {
        name : selectn('away.abbreviation', data) || 'TBC',
        logo : selectn('away.logo', data) || '',
        color : selectn('away.color', data) || ''
      },
      col : [
        [
          {
            type : 'dataVisIcons',
            data : {
              homeTotal : selectn('home.scrumstotal.value', data),
              homeWon : selectn('home.scrumswon.value', data),
              awayTotal : selectn('away.scrumstotal.value', data),
              awayWon : selectn('away.scrumswon.value', data),
              text : selectn('away.scrumswon.name', data)
            }
          }, {
            type : 'dataVisIcons',
            data : {
              homeTotal : selectn('home.totallineouts.value', data),
              homeWon : selectn('home.lineoutswon.value', data),
              awayTotal : selectn('away.totallineouts.value', data),
              awayWon : selectn('away.lineoutswon.value', data),
              text : selectn('away.lineoutswon.name', data)
            }
          }
        ],
        [
          {
            type : 'dataVisPie',
            data : {
              homeTotal : (selectn('home.tackles.value', data) * 1) + (selectn('home.missedtackles.value', data) * 1),
              homeWon : selectn('home.tackles.value', data),
              awayTotal : (selectn('away.tackles.value', data) * 1) + (selectn('away.missedtackles.value', data) * 1),
              awayWon : selectn('away.tackles.value', data),
              text : selectn('away.tackles.name', data)
            }
          }
        ]
      ]
    }
  },

  getMatchDefendingRL : function () {
    return {}
  },

  getMatchDiscipline : function (edition, data) {

    return {
      title : translate(edition, 'Discipline'),
      split : false,
      home : {
        name : selectn('home.abbreviation', data) || 'TBC',
        logo : selectn('home.logo', data) || '',
        color : selectn('home.color', data) || ''
      },
      away : {
        name : selectn('away.abbreviation', data) || 'TBC',
        logo : selectn('away.logo', data) || '',
        color : selectn('away.color', data) || ''
      },
      col : [
        [
          {
            type : 'dataVisCount',
            data : {
              homeTotal : selectn('home.penaltiesconceded.value', data),
              homeWon : selectn('home.penaltiesconceded.value', data),
              awayTotal : selectn('away.penaltiesconceded.value', data),
              awayWon : selectn('away.penaltiesconceded.value', data),
              text : selectn('away.penaltiesconceded.name', data)
            }
          }
        ],
        [
          {
            type : 'table',
            data : [
              {
                homeValue : selectn('home.redcards.value', data),
                awayValue : selectn('away.redcards.value', data),
                text : selectn('away.redcards.name', data)
              }, {
                homeValue : selectn('home.yellowcards.value', data),
                awayValue : selectn('away.yellowcards.value', data),
                text : selectn('away.yellowcards.name', data)
              }, {
                homeValue : selectn('home.totalfreekicksconceded.value', data),
                awayValue : selectn('away.totalfreekicksconceded.value', data),
                text : selectn('away.totalfreekicksconceded.name', data)
              }
            ]
          }
        ]
      ]
    }
  },

  /*
  getTeamStats: function(oData){
    // takes the home team and the away team and searches the table if available to calculate the positions.
    var aStatsBox = [];
    if(typeof oData !== 'undefined' &&
      typeof oData.standings !== 'undefined' &&
      typeof oData.standings.children !== 'undefined'
    ){
      var aGroups     = oData.standings.children || [];
      var oStandings  = {};
      var iGroupLen   = aGroups.length;
      var hHomeTeam   = this.getHomeTeam();
      var hAwayTeam   = this.getAwayTeam();
      var bFound      = false;
      var aEntries    = [];

      if(iGroupLen > 1){
        // we have more then 1 group we need to find the correct group
        for (var i = 0; i < iGroupLen; i++) {
          oStandings = aGroups[i];
          aEntries = (oStandings.standings && oStandings.standings.entries) ? oStandings.standings.entries : [];
          for (var x = 0; x < aEntries.length; x++) {
            var hTeam = aEntries[x];
            if(hTeam.team.id == hHomeTeam.id){
               bFound = true;
            }
            if(bFound){
               break;
            }
          }
          if(bFound){
            break;
          }
        }
      }else{
        // only one group so must be in that group
        oStandings = aGroups[0];
        aEntries = (oStandings.standings && oStandings.standings.entries) ? oStandings.standings.entries : [];
      }

      var iEntryLen   = aEntries.length;
      var hStatsData  = {};

      for (var x = 0; x < iEntryLen; x++) {
          var hTeam = aEntries[x];
          for (var j = 0; j < hTeam.stats.length; j++) {
              if(typeof hStatsData[hTeam.stats[j].type] === 'undefined'){
                  hStatsData[hTeam.stats[j].type] = [];
              }
              var hTmpdata = {
                  value: (hTeam.stats[j].value*1),
                  description: hTeam.stats[j].description,
                  displayValue: hTeam.stats[j].displayValue,
                  team: hTeam.team.id
              };
              hStatsData[hTeam.stats[j].type].push(hTmpdata);
          }
      }

      // if neither team has played again don't show the stats.
      if(typeof hStatsData['gamesplayed'] !== 'undefined'){
        if(typeof hStatsData['gamesplayed'][0] !== 'undefined' && hStatsData['gamesplayed'][0].value == 0 && typeof hStatsData['gamesplayed'][1] !== 'undefined' && hStatsData['gamesplayed'][1].value == 0){
          return;
        }
      }else{
        return; // no played data so i assume never played.
      }

      // priority order of the stats, so if i can't find 1 move on to the next
      var aPriorityStats  = ['pointsfor','pointsagainst','pointsdifference','triesfor','triesagainst','triesdifference','gameswon','gameslost','gamesdrawn','bonuspoints','bonuspointslosing','bonuspointstry','gamesbye','points','gamesplayed'];
      var aReverseStats   = [true,false,true,true,false,true,true,false,true,true,false,true,true,true,true];
      var iPriorityLen = aPriorityStats.length;
      var aStatsToSort = [];
      for (var x = 0; x < iPriorityLen; x++) {
        if(typeof hStatsData[aPriorityStats[x]] !== 'undefined'){
          aStatsToSort.push(aPriorityStats[x]) ;
        }
        if(aStatsToSort.length >= 4){
          break;
        }
      }

      // sort each piece of data
      var iStatLen = aStatsToSort.length;
      for (var x = 0; x < iStatLen; x++) {
          var aStats = hStatsData[aStatsToSort[x]];
          var aSorted = aStats.sort(fValueCompare);
          var bReverse = aReverseStats[x] || false;
          if(bReverse){
              aSorted.reverse();
          }

          // loop the records looking for teams
          var iSortedLen = aSorted.length;
          var hBoxData = {
              name: aSorted[0].description,
              home:{
                  abbreviation:'',
                  position:0,
                  value:0,
                  displayValue:0
              },
              away:{
                  abbreviation:'',
                  position:0,
                  value:0,
                  displayValue:0
              }
          };
          var iTeamWatch = 0;
          for (var i = 0; i < iSortedLen; i++) {
              var oStatData = aSorted[i];
              if(oStatData.team == hHomeTeam.id){
                  hBoxData.home.color = hHomeTeam.color;
                  hBoxData.home.abbreviation = hHomeTeam.abbreviation;
                  hBoxData.home.position = i+1;
                  hBoxData.home.value = oStatData.value;
                  hBoxData.home.displayValue = oStatData.displayValue;
                  iTeamWatch++;
              }else if(oStatData.team == hAwayTeam.id){
                  hBoxData.away.color = hAwayTeam.color;
                  hBoxData.away.abbreviation = hAwayTeam.abbreviation;
                  hBoxData.away.position = i+1;
                  hBoxData.away.value = oStatData.value;
                  hBoxData.away.displayValue = oStatData.displayValue;
                  iTeamWatch++;
              }
          }
          // if we have found at least 1 team allow it to continue.
          if(iTeamWatch == 2){
              aStatsBox.push(hBoxData);
          }
      }

      function fValueCompare(a,b) {
        if(a.value < b.value){
          return -1;
        }
        if(a.value > b.value){
          return 1;
        }
        return 0;
      }
    }
    this.data.teamStatsBox = aStatsBox;
  },
  */

  getMatchLineUp : function ( edition, params, data ) {

    const teamSize  = params.sport === 'rugby-league' ? 13 : 15 /* split the team here */
    const homeSquad = selectn('home.squad', data) || []
    const homeTeam  = homeSquad.slice(0, teamSize)
    const homeReserve = homeSquad.slice(teamSize)
    const awaySquad = selectn('away.squad', data) || []
    const awayTeam  = awaySquad.slice(0, teamSize)
    const awayReserve = awaySquad.slice(teamSize)
    const show = homeTeam.length > 0 && awayTeam.length > 0

    return {
      text : {
        col2 : translate(edition, 'No.'),
        col3 : translate(edition, 'Name'),
        split : translate(edition, 'Replacements'),
        scoring : translate(edition, 'Scoring'),
        attacking : translate(edition, 'Attacking'),
        defending : translate(edition, 'Defending'),
        discipline : translate(edition, 'Discipline'),
        note : translate(edition, '*Players currently on the pitch are shown in bold')
      },
      home : {
        name : selectn('home.abbreviation', data),
        logo : selectn('home.logo', data),
        team : homeTeam || [],
        reserves : homeReserve || []
      },
      away : {
        name : selectn('away.abbreviation', data),
        logo : selectn('away.logo', data),
        team : awayTeam || [],
        reserves : awayReserve || []
      },
      gameState : selectn('gameState', data),
      sport : params.sport,
      show
    }
  },

  getGlossary : function ( edition, sport = 'rugby', data = {} ) {

    if ( sport === 'rugby-league' ) {
      delete data.glossary.teamStats.lineoutwonsteal
      delete data.glossary.teamStats.lineoutswon
      delete data.glossary.playerStats.lineoutwonsteal
      delete data.glossary.playerStats.lineoutswon
    }

    data.glossary.glossaryTitle = translate(edition, 'Glossary') || ''

    return data.glossary
  },

  getStandings : function ( edition, standingsNode, params ) {

    const typesToShow = [ /* stats type in order of display + special team to show teamname */
      'rank',
      'team',
      'gamesplayed',
      'pointsdifference',
      'points'
    ]

    const standingsCopy = Object.assign( {}, standingsNode )
    standingsCopy.name  = translate(edition, 'Standings')

    const standings     = common.getStandingsData( standingsCopy, typesToShow, params.sport, 'gamepackage', edition )
    const standingsLink = helpers.getStandingsLink( edition, params )

    return { ...standings, link: { ...standingsLink, external:false } }
  },

  getMatchCommentary : function ( edition, params, query, data ) {
    return {
      text : {
        viewAll : translate(edition, 'Match Commentary'),
        viewKey : translate(edition, 'Key Events'),
        allBtn : translate(edition, 'All Commentary'),
        keyBtn : translate(edition, 'Key Events')
      },
      sport : params.sport,
      events : selectn('events', data) || [],
      link : common.buildLinkObject({
        text : translate(edition, 'Full Commentary'),
        tracking : [ 'rugby', 'game', 'subnav', 'commentary' ],
        params : {
          pageType : 'commentary',
          sport : params.sport,
          league : params.league,
          gameId : params.gameId,
          platform: params.platform,
          webview: params.webview
        },
        query : query,
        edition : edition
      })
    }
  },

  getLastFive : function ( edition, params, data, teamId, headToHead = false, query={} ) {

    const dataLen = data.length
    let currTeam = {}
    for (let i = 0; i < dataLen; i++) {
      const dataTeamId = selectn('team.id', data[i]) || 0
      if (dataTeamId === teamId) {
        currTeam = data[i]
        break
      }
    }

    const dataEvents    = selectn('events', currTeam) || []
    const evtLen        = dataEvents.length
    const homeTeamURL   = common.buildURL( selectn( 'team.links[0].href', currTeam ) || '#' )
    const homeTeamLink  = common.buildLinkObject({
      tracking : [ 'rugby', 'game', 'subnav', 'history' ],
      href : homeTeamURL,
      edition : edition
    })

    const team = {
      name : selectn('team.abbreviation', currTeam) || selectn('team.displayName', currTeam) || '',
      abbreviation : selectn('team.abbreviation', currTeam) || '',
      logo : common.getTeamLogo( selectn( 'team', currTeam ) ) || '',
      link : homeTeamLink || {},
      uid: selectn('team.uid', currTeam) || ''
    }
    let events = []

    for (let i = 0; i < evtLen; i++) {

      const eventDetails  = dataEvents[i]
      const awayTeamURL   = common.buildURL( selectn( 'opponent.links[0].href', eventDetails ) || '#' )
      const awayTeamLink  = common.buildLinkObject({
        tracking : [ 'rugby', 'game', 'subnav', 'history' ],
        href : awayTeamURL,
        edition : edition
      })
      const opposition = {
        name : selectn('opponent.abbreviation', eventDetails) || selectn('opponent.displayName', eventDetails) || '',
        abbreviation : selectn('opponent.abbreviation', eventDetails) || '',
        logo : common.getTeamLogo( selectn('opponent', eventDetails) ) || '',
        link : awayTeamLink || {},
        uid: selectn('opponent.uid', eventDetails) || ''
      }

      let matchURL = common.buildURL( selectn('links[0].href', eventDetails) || '#' )
      //open match head to head links in app itself
      //but top stories will not refresh, need to fix

      if(params.platform && params.webview) {
        let newPageType = 'match'
        if(edition.language === 'es' && params.pageType === 'match') {
          newPageType = 'game'
        }
        let uriObj = parseUri(matchURL) || {}
        let queryObj = Object.assign({},{ ...query,...uriObj.queryKey })
        let hrefConfig = Object.assign({}, { ...params, ...uriObj.queryKey, query: queryObj, pageType: newPageType })
        matchURL = common.createHref({ pageType: newPageType , ...hrefConfig })
      }
      const matchLink  = common.buildLinkObject({
        tracking : [ 'rugby', 'game', 'subnav', 'history' ],
        href: matchURL,
        edition : edition,
        params : params
      })

      let game = {
        home : {},
        away : {},
        date : selectn('gameDate', eventDetails) || '',
        league : selectn('leagueName', eventDetails) || '',
        score : selectn('homeTeamScore', eventDetails) + '-' + selectn('awayTeamScore', eventDetails),
        link : matchLink || {},
        result : selectn('gameResult', eventDetails) || '',
        resultValue : selectn('gameResult', eventDetails) || ''
      }

      if (eventDetails.homeTeamId === currTeam.team.id) {
        game.home = team
        game.away = opposition
      } else {
        game.home = opposition
        game.away = team
      }

      events.push(game)
    }

    let sDisplayTitle = headToHead ? translate( edition, 'Head To Head Record' ) : selectn('team.displayName', currTeam) + ' ' + translate( edition, 'Form' )
    let displayMessage = ''
    if(events.length < 1) {
      displayMessage = translate(edition, 'No Data Available')
    }
    return {
      text : {
        title : sDisplayTitle,
        col1 : translate( edition, 'Last Five Games' ),
        col2 : translate( edition, 'Date' ),
        col3 : translate( edition, 'Competition' )
      },
      team : team,
      data : events,
      displayMessage: displayMessage
    }
  },

  /**
   * build links for tertiary nav
   * @param  {Object} edition    Edition details
   * @param  {Object} params     Router params
   * @param  {Object} query      Request query params
   * @param  {Object} hidden     Links to be displayed
   * @param  {String} gameState  Game state
   * @return {Array}             Game package links
   */
  buildNav : function ( edition = {}, params = {}, query = {}, hidden = {}, gameState = '', rostersNode ) {
    const LINEUPS = 'lineups'
    let standingsPageType = 'table'
    let matchPageType = 'match'
    if(edition.language === 'es' || edition.language === 'pt') {
      standingsPageType = 'standings'
      hidden.standings = hidden.table
    }
    if(edition.language === 'es') {
      matchPageType = 'game'
    }
    const linksToShow = {
      pregame : [ matchPageType, 'preview', 'commentary', LINEUPS , standingsPageType, 'conversation' ],
      live : [ matchPageType, 'commentary', 'matchstats', 'playerstats', LINEUPS , standingsPageType, 'conversation' ],
      final : [ matchPageType, 'report', 'commentary', 'matchstats', 'playerstats', LINEUPS , standingsPageType, 'conversation' ]
    }

    const linkDescriptors = {
      match : {
        text : translate(edition, 'links.event.summary.metadata.text.rugby')
      },
      game : {
        text : translate(edition, 'links.event.summary.metadata.text.rugby')
      },
      report : {
        text : translate(edition, 'links.event.recap.metadata.text.rugby')
      },
      preview : {
        text : translate(edition, 'links.event.preview.metadata.text.rugby')
      },
      commentary : {
        text : translate(edition, 'links.event.commentary.metadata.text.rugby')
      },
      matchstats : {
        text : translate(edition, 'links.event.matchstats.metadata.text.rugby')
      },
      playerstats : {
        text : translate(edition, 'links.event.playerstats.metadata.text.rugby')
      },
      lineups : {
        text : translate(edition, 'links.event.lineups.metadata.text.rugby')
      },
      table : {
        text : translate(edition, 'links.event.table.metadata.text.rugby'),
        external: 'standings'
      },
      standings : {
        text : translate(edition, 'links.event.table.metadata.text.rugby'),
        external: 'standings'
      },
      conversation : {
        text : translate(edition, 'links.event.conversation.metadata.text.rugby')
      }
    }

    const links     = []
    const linkList  = linksToShow[gameState] || []
    const linkLen   = linkList.length
    const isLineupsAvailable = selectn('[0].roster',rostersNode)
    for (let i = 0; i < linkLen; i++) {
      const linkName = linkList[i] || ''
      if(linkName === LINEUPS && typeof isLineupsAvailable === UNDEFINED)
        continue
      if ( !hidden[linkName] ) {
        const details = linkDescriptors[linkName]

        // skip if details not available
        if (typeof details !== UNDEFINED) {
          let queryClone = Object.assign({}, query)
          if ((linkName === 'table' || linkName == 'standings') && details.external ) {
            delete queryClone.gameId
            delete queryClone.league
          }
          const linkDetails = common.buildLinkObject({
            text : linkName === 'match' && gameState === 'live' ? translate(edition, 'links.event.live.metadata.text.rugby') : details.text,
            external : details.external,
            tracking : [ params.sport, 'game', 'subnav', linkName ],
            params : {
              pageType : linkName,
              sport : params.sport,
              league : params.league,
              gameId : params.gameId,
              platform: params.platform,
              webview: params.webview
            },
            query : queryClone,
            edition : edition
          })
          //make link external for webviews to remove react-router-link class
          if(params.platform) {
            if(details.external) {
              linkDetails.external = details.external
            }
          }
          links.push(linkDetails)
        }
      }
    }

    return links
  },

  getMatchConversation : function ( edition = {}, params = {} ) {
    return {
      text : {
        heading : translate(edition, 'Conversation'),
        description : translate(edition, 'facebook.conversation.account_policy')
      },
      href : edition.domain + common.createHref({
        sport : params.sport,
        league : params.league,
        gameId : params.gameId,
        pageType : 'conversation'
      })
    }
  },

  getNews : function ( edition = {}, newsNode = {}, leagueName = '' ) {
    const items = []
    let articles = newsNode.articles || []
    if (articles['constructor'] !== Array) {
      articles = []
    }
    articles.map(article => {
      const { headline } = article
      let image

      // skip to next iteration if headline invalid
      if (typeof headline !== 'string' || headline === '') {
        return
      }

      image = {
        url : common.getCombinerImage( selectn('images[0].url', article) )
      }

      let articleURI = selectn('links.web.href', article) || '#'
      articleURI = common.buildURL( articleURI )

      items.push({
        headline : article.headline,
        description : article.description,
        //href : selectn('links.web.href', article) || '#',
        href : articleURI,
        image
      })

    })

    const newsTitle = []
    if ( leagueName ) {
      newsTitle.push( leagueName )
    }
    newsTitle.push( translate( edition, 'News' ) )
    return {
      //href : common.createHref({
      //  ...params,
      //  pageType : 'match-coverage'
      //}),
      items,
      title : newsTitle.join(' ')
    }
  }
}

const page = {
  /**
   * compose data for scorecard page
   * @param  {Array}  rostersNode   rosters node
   * @param  {Array}  allInnings    details of all innings
   * @param  {Number} currentPeriod current innings
   * @param  {String} gameState     game state
   * @param  {Object} matchFlags    flags for this match
   * @return {Object}               scorecard data
   */
  getScorecard : function ( rostersNode = [], allInnings, currentPeriod, gameState, matchFlags ) {
    let inningInfo = helpers.getOrderedInnings( rostersNode, allInnings, currentPeriod, gameState, matchFlags )
    const scorecard = inningInfo
    return scorecard
  },

  /**
   * @param {Object} articleNode article node
   * return required data to fetch related markup for sCore
   * @return {Object} article data required to fetch rendered markup
   */
  getArticleInfo : function (articleNode) {
    return articleNode ? {
      id :    articleNode.id || null,
      type :  articleNode.type || null
    }
    : null
  }
}

export const gamePackage = {

  processData : function ( res, edition, params, location ) {

    //const { query = {} } = location
    const query = common.getQuery(edition, params, location)
    // Select Nodes from API response
    const gameInfo        = selectn('data.gameInfo', res) || {}
    const competitionNode = selectn('data.header.competitions[0]', res) || {}
    const rostersNode     = selectn('data.rosters', res) || []
    const boxScoreNode    = selectn('data.boxscore', res) || []
    const articleNode     = selectn('data.article', res) || {}
    const standingsNode   = selectn('data.standings', res) || {}
    const newsNode        = selectn('data.news', res) || {}
    const lastFiveNode    = selectn('data.lastFiveGames', res) || {}
    const HeadToHeadNode  = selectn('data.headToHeadGames', res) || {}

    /* Process data */
    const filteredDetails = modules.setMatchDetails( params, rostersNode, competitionNode, boxScoreNode )

    /* Build data for modules */
    const matchDetails    = modules.getMatchDetails( edition, gameInfo, competitionNode )
    const matchStats      = modules.getMatchStats( edition, params, query, filteredDetails, boxScoreNode )
    const matchLineUp     = modules.getMatchLineUp( edition, params, filteredDetails )
    const matchCommentary = modules.getMatchCommentary( edition, params, query, filteredDetails )
    const matchEvents     = modules.getMatchEvents( edition, filteredDetails )
    let matchAttacking = ''
    let matchDefending = ''
    if( params.sport === 'rugby' ) {
      matchAttacking  = modules.getMatchAttacking( edition, filteredDetails )
      matchDefending  = modules.getMatchDefending( edition, filteredDetails )
    } else {
      matchAttacking  = modules.getMatchAttackingRL( edition, filteredDetails )
      matchDefending  = modules.getMatchDefendingRL( edition, filteredDetails )
    }
    const matchDiscipline = modules.getMatchDiscipline( edition, filteredDetails )
    const matchGlossary   = modules.getGlossary( edition, params.sport, filteredDetails )
    const article         = modules.getArticle( articleNode, params )
    const headToHead      = modules.getLastFive( edition, params, HeadToHeadNode, filteredDetails.home.id || 0, true, query )
    const matchHomeForm   = modules.getLastFive( edition, params, lastFiveNode, filteredDetails.home.id || 0,false, query )
    const matchAwayForm   = modules.getLastFive( edition, params, lastFiveNode, filteredDetails.away.id || 0,false, query )
    const matchConversation = modules.getMatchConversation( edition, params )
    const editionDateFormat = edition.editionDateFormat || ''
    const matchSummary    = eventSummary.getMatchSummary( params.sport || 'rugby', edition, filteredDetails )
    const leagueUid = selectn('data.header.league.uid', res) || {}
    const leagueSeason = selectn('data.header.season.year', res) || ''
    let leagueName = selectn('data.header.league.name', res) || ''
    leagueName += leagueSeason ? ' ' + leagueSeason : ''

    const league = {
      'id' : selectn('data.header.league.id', res) || '',
      'uid' : leagueUid,
      'name' : leagueName,
      'season' : leagueSeason,
      'isTournament' : selectn('data.header.league.isTournament', res)
    }
    const standings       = league.isTournament ? modules.getStandings( edition, standingsNode, params ) : {}

    const matchDescription = ''
    const gameState = common.getGameState( selectn( 'status.type.state', competitionNode ) )
    const gameStrip = common.getGameStrip( competitionNode, leagueName, gameState, 'rugby', edition.timeZoneBucket, params, '', true, edition.language, editionDateFormat )

    const gameStateClass = common.getGameStateClass( gameState )
    const news = modules.getNews( edition, newsNode, leagueName )
    const matchCoverage = {}
    const meta = helpers.getMetaData( edition, params, competitionNode, gameStrip, gameInfo, leagueName, gameState, league, matchCoverage, matchDescription )

    /* Build the nav */
    const isWebView = params.platform ? true : false
    const hiddenLinks = {}
    const hasStats = selectn('home.possession.value', filteredDetails) ||selectn('home.metres.value', filteredDetails) || 0

    /* hide links flag if no data */
    if (( standings.teams && standings.teams.length === 0 ) || (league.isTournament === false)) {
      hiddenLinks.table = 1
      hiddenLinks.standings = 1
    }
    if ( article.id === 0 ) {
      hiddenLinks.preview = 1
      hiddenLinks.report = 1
    }
    if ( matchCommentary.events && matchCommentary.events.length === 0 ) {
      hiddenLinks.commentary = 1
    }
    if (hasStats <= 1) {
      hiddenLinks.matchstats = 1
      hiddenLinks.playerstats = 1
    }

    if (isWebView === true) {
      hiddenLinks.table = 1
    }
    //hide the conversation tab if web view or the Appearance is dark or light 
    hiddenLinks.conversation = 1
    
    const links     = modules.buildNav( edition, params, query, hiddenLinks, gameState, rostersNode )
    const polling   = helpers.shouldPoll( competitionNode.date, gameState )
    const analytics = helpers.getAnalytics( params, gameStrip.teams, meta, gameState )

    return {
      standings,
      links,
      headToHead,
      gameStrip,
      gameStateClass,
      gameState,
      leagueUid,
      meta,
      news,
      polling,
      analytics,

      matchDetails,
      matchStats,
      matchLineUp,
      matchCommentary,
      matchEvents,
      matchAttacking,
      matchDefending,
      matchDiscipline,
      matchGlossary,
      matchHomeForm,
      matchAwayForm,
      matchConversation,
      matchSummary,
      showGameStrip: true,
      showGameDetailFooter : true,
      article,
      HeadToHeadNode
    }
  },

  page : page,

  modules : modules,

  helpers : helpers

}

export default gamePackage



// WEBPACK FOOTER //
// ../app/lib/transform/parsers/rugby/gamePackage.js